import React, {useState} from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CouponIcon from '@material-ui/icons/CardGiftcard';
import SlideCard from "../../SlideCard";
import DiscountModal from "./DiscountModal";
import i18n from "../../../../i18nextInitiator";
import {connect} from "react-redux";
import {formatPrice} from "../../../../actions/actionCreators";

/**
 * Translation function.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');
/**
 * maps state to component props.
 * @param state
 */
const mapStateToProps = state => ({ ...state,
    discountAmount: state.invoice.bill && state.invoice.bill.discount_amount,
    couponApplied: state.order.couponApplied,
});

const Discount = props => {

    const [showDiscountModal, setShowDiscountModal] = useState(false)

    return <>
        {
            props.couponApplied || props.discountAmount
                ?
                <Grid container justifyContent={"space-between"}>
                    <Button
                        startIcon={<CouponIcon/>}
                        variant={"text"}
                        color={"secondary"}
                        size={"large"}>
                        { t("discount.accepted") }
                    </Button>
                    <Button
                        color={"secondary"}
                        variant={"text"}
                        size={"large"}>
                        { t("discount.amount", {amount: formatPrice(props.discountAmount)}) }
                    </Button>
                </Grid>
                :
                <Grid container justifyContent={"space-between"} onClick={() => setShowDiscountModal(true)}>
                    <Button
                        startIcon={<CouponIcon/>}
                        variant={"text"}
                        color={"primary"}
                        size={"large"}>
                        { t("discount.title") }
                    </Button>
                    <Button color={"secondary"}
                            variant={"outlined"}
                            size={"large"}>
                        { t("discount.enter") }
                    </Button>
                </Grid>
        }
        <SlideCard
            title={t("discount.name")}
            show={showDiscountModal}
            close={() => setShowDiscountModal(false)}
        >
            <DiscountModal close={() => setShowDiscountModal(false)}/>
        </SlideCard>
    </>
}

export default connect(mapStateToProps)(Discount)